import React from "react";

const Condizioni = () => {
  return <div>Condizioni</div>;
};

export default Condizioni;
